"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _publication = require("../common/utils/publication");
var setup = function setup(_ref) {
  var latestAsset = _ref.latestAsset;
  return {
    description: 'Add a RAML or an OAS spec that describes the structure of a REST API to use in Anypoint Studio or Flow Designer.',
    flows: [{
      label: 'Upload a RAML',
      fields: [(0, _publication.apiVersionField)(latestAsset), {
        name: 'mainFile',
        inputType: 'file',
        classifier: 'raml',
        extensions: ['.raml'],
        required: true,
        hasMainFile: true,
        mainFileProperty: 'mainFile'
      }]
    }, {
      label: 'Upload an OAS',
      callout: null,
      fields: [(0, _publication.apiVersionField)(latestAsset), {
        name: 'mainFile',
        inputType: 'file',
        classifier: 'oas',
        extensions: ['.json', '.yaml'],
        required: true,
        hasMainFile: true,
        mainFileProperty: 'mainFile'
      }]
    }]
  };
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map